const formMedicalPrograms = {
    'PMD_1': [
        {id: '63c1f32f-c8f4-4f5b-81a9-79b8452d6545', name: 'Серцево-судинні та цереброваскулярні захворювання, цукровий діабет 2-го типу та хронічні хвороби нижніх дихальних шляхів'}
    ],
    'INSULIN_1': [
        {id: '857588d8-9e12-4935-96c4-b08e95d19dce', name: 'Інсуліни картриджи та шприц ручки з доплатою'},
        {id: 'e9c6beeb-b19f-4b97-b42a-020c5c996c56', name: 'Інсуліни з доплатою'},
        {id: '9a1364d7-2c61-4fe8-b889-ea788dbb7467', name: 'Інсуліни з доплатою (old)'},
        {id: 'cda113e4-b8dd-4ec4-a878-3d1c7eae49da', name: 'Інсуліни флакони безоплатно'},
        {id: '8efe29df-18bd-4d49-8995-c3f7e44d9e12', name: 'Інсуліни картриджи та шприц ручки безоплатно'},
        {id: '7335a30e-61f2-42b0-9ed4-2afe847bba16', name: 'Інсуліни безоплатно'},
        {id: '9994be00-47b4-4969-800e-87a767751b47', name: 'Інсуліни безоплатно (old)'}
    ],
    'ND_1': [
        {id: '14e19712-b443-4391-b0f7-aba8e8662459', name: 'Нецукровий діабет'}
    ],
    'PSYCHIATRY': [
        {id: 'f217889f-736f-462c-8f8b-ed99edddb3be', name: 'Розлади психіки та поведінки'},
        {id: '9d94a21b-ec70-4b91-946a-981f4db8d2b9', name: 'Епілепсія'}
    ]
};

export default formMedicalPrograms;